// src/modules/common/components/Typography/withEmphasis/index.js
import withEmphasis from "./withEmphasis";

export default withEmphasis;
